import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Avatar, Box, Container, IconButton } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { green, pink } from '@mui/material/colors';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';
// import { DOMParser } from 'xmldom';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export default function BillTable(props) {
  const { t } = useTranslation();
  const [percentCompleted, setPercentCompleted] = useState(0);
  const [invoiceData, setInvoiceData] = useState([]);
  const [clickedInvoiceId, setClickedInvoiceId] = useState("");

  useEffect(() => {
    if (props.tableData.length > 0) {
      setInvoiceData(props.tableData)
    } else {
      setInvoiceData([])
    }
  }, [props])


  const fetchPdf = (invoiceNumber) => {
    setClickedInvoiceId(invoiceNumber);
    var reqXml = `<Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/">
      <Body>
          <callZFICA_XSTRING_TO_PDF xmlns="http://wbsedcl.in/poc/">
              <invoiceId xmlns="">${invoiceNumber}</invoiceId>
          </callZFICA_XSTRING_TO_PDF>
      </Body>
    </Envelope>`;
    // var reqXml = `<Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/">
    //   <Body>
    //       <callZFICA_XSTRING_TO_PDF xmlns="http://wbsedcl.in/poc/">
    //           <invoiceId xmlns="">100000003395</invoiceId>
    //       </callZFICA_XSTRING_TO_PDF>
    //   </Body>
    // </Envelope>`;
    axios.post(
      `${process.env.REACT_APP_API_URL}FormMonthEndLayoutService/FormMonthEndLayout?wsdl`,
      reqXml,
      {
        headers: {
          'Content-Type': 'text/xml',
          Accept: 'text/xml'
        },
        // onDownloadProgress: progressEvent => {
        //   // const total = parseFloat(progressEvent.currentTarget.responseHeaders['Content-Length'])
        //   // const current = progressEvent.currentTarget.response.length
        //   console.log(progressEvent, "progressEvent");
        //   let percentCompleted = Math.round(
        //     (progressEvent.loaded * 100) / progressEvent.total
        //   )
        //   console.log('completed: ', percentCompleted)
        //   if (percentCompleted == 100) {
        //     setPercentCompleted(0);
        //   } else {
        //     setPercentCompleted(percentCompleted);
        //   }
        // }
      }
    )
      .then((response) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(response.data, 'text/xml');
        const status = doc.getElementsByTagName('return');
        const res = status[0]["childNodes"][0]["data"];
        console.log(res, typeof res, "xml2json2");
        console.log(res.includes(errorKeyword), "xml2json2");

        let errorKeyword = "Something went wrong";
        if (res.includes(errorKeyword)) {
          props.setDownloadError();
          props.handleErrorBar();
          setClickedInvoiceId("");
        } else {
          downloadPDF(res, invoiceNumber);
          setClickedInvoiceId("");
        }

        // // create file link in browser's memory
        // const href = URL.createObjectURL(response.data);

        // // create "a" HTML element with href to file & click
        // const link = document.createElement('a');
        // link.href = href;
        // link.setAttribute(
        //   'download',
        //   `${invoiceNumber}.pdf`,
        // ); //or any other extension
        // document.body.appendChild(link);
        // link.click();

        // // clean up "a" element & remove ObjectURL
        // document.body.removeChild(link);
        // URL.revokeObjectURL(href);
      })
      .catch((e) => {
        console.log(e, "xml2json error");
        setPercentCompleted(0);
        setClickedInvoiceId("");
      });

  }

  function downloadPDF(base64Pdf, invoiceNumber) {
    const linkSource = `data:application/pdf;base64,${base64Pdf}`;
    const downloadLink = document.createElement("a");
    const fileName = `${invoiceNumber}.pdf`;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
    downloadLink.remove();
  }

  return (
    <TableContainer component={Paper}>
      <Table sx={{}} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell align="center">{t("Invoice Number")}</StyledTableCell>
            <StyledTableCell align="center">{t("Statement Month")}</StyledTableCell>
            {/* <StyledTableCell align="right">Bill Due Date</StyledTableCell>
            <StyledTableCell align="right">Bill Amount before Due Date</StyledTableCell>
            <StyledTableCell align="right">Bill Amount after Due Date</StyledTableCell> */}
            <StyledTableCell align="center">{t("View Statement")}</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invoiceData.map((row, index) => (
            <StyledTableRow key={index.toString()}>
              <StyledTableCell component="th" scope="row" align="center">
                {row?.invoiceId}
              </StyledTableCell>
              <StyledTableCell align="center">{row?.statementMonth}</StyledTableCell>
              <StyledTableCell align="center" sx={{ pl: 5 }}>
                {(clickedInvoiceId == row?.invoiceId) ?
                  <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                  </Box>
                  :
                  <IconButton color="primary" aria-label="Download pdf">
                    <Avatar sx={{ bgcolor: green[500] }} onClick={() => { fetchPdf(row?.invoiceId) }}>
                      <PictureAsPdfIcon />
                    </Avatar>
                  </IconButton>
                }
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
